import { useEffect } from 'react';

import { useBrandingStore } from '@/stores/branding.store';

export function usePageTitle(title?: string) {
  const companyName = useBrandingStore((s) => s.companyName);

  useEffect(() => {
    document.title =
      title && companyName ? `${title} | ${companyName}` : title || companyName || '';
  }, [title, companyName]);
}
